class Timeline {
  constructor() {
    const timelineSliders = document.querySelectorAll(".js-timeline");
    const that = this;

    if (timelineSliders.length > 0) {
      Promise.all([
        import(/* webpackChunkName: "library-swiper" */ "swiper"),
        import(
          /* webpackChunkName: "library-swiper-modules" */ "swiper/modules" // eslint-disable-line
        ),
      ])
        .then(([{ default: Swiper }, { Navigation }]) => {
          timelineSliders.forEach((el) => {
            this.init(el, that, Swiper, Navigation);
          });
        })
        .catch((err) => console.log(err)); // eslint-disable-line
    }
  }

  /* eslint-disable */
  progress(swiper, progress) {
    const currentProgressPercentage = progress.progress * 100;
    Array.from(swiper.querySelectorAll(".swiper-current-progress")).forEach(
      (el) => {
        el.style.width = currentProgressPercentage + "%";
      }
    );
  }

  init(el, that, Swiper, Navigation) {
    const timeline = new Swiper(el.querySelector(".swiper-container"), {
      modules: [Navigation],
      grabCursor: true,
      spaceBetween: 24,
      slidesPerView: 1.1,

      // Navigation arrows
      navigation: {
        nextEl: el.querySelector(".js-timeline-button-next"),
        prevEl: el.querySelector(".js-timeline-button-prev"),
      },

      // Breakpoints
      breakpoints: {
        576: {
          slidesPerView: 2,
          slidesOffsetAfter: 100,
        },
        768: {
          slidesPerView: 3.6,
          slidesOffsetAfter: 600,
        },
      },

      // Porgress
      on: {
        progress(progress) {
          const swiper = el;
          that.progress(swiper, progress, el);
        },
      },
    });
  }
  /* eslint-enable */
}

export default Timeline;
